module.exports = __webpack_public_path__ + "static/media/arrow.48b3acc9.svg";